import { render, staticRenderFns } from "./DiscoverListingFeatureCard.vue?vue&type=template&id=3037dd11&"
import script from "./DiscoverListingFeatureCard.vue?vue&type=script&lang=js&"
export * from "./DiscoverListingFeatureCard.vue?vue&type=script&lang=js&"
import style0 from "./DiscoverListingFeatureCard.vue?vue&type=style&index=0&id=3037dd11&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports